export default __webpack_public_path__ + "static/media/dropit.fed8fb8b.gif";